import { on } from "@ngrx/store";
import { ApplicationStore } from "../../../application.state";
import { DataLocationsActions } from "./locations.actions";

// **************************************************************************
// LOCATIONS REDUCER
// **************************************************************************

const load = on(DataLocationsActions.load, (state: ApplicationStore) => ({
    ...state,
    data: {
        ...state.data,
        location: {
            ...state.data.location,
            locationsLoading: true,
        },
    },
}));

const loadSuccess = on(DataLocationsActions.loadSuccess, (state: ApplicationStore, { locations }) => ({
    ...state,
    data: {
        ...state.data,
        location: {
            ...state.data.location,
            locations,
            locationsLoading: false,
        },
    },
}));

const loadFailure = on(DataLocationsActions.loadFailure, (state: ApplicationStore, { error }) => ({
    ...state,
    data: {
        ...state.data,
        error,
        location: {
            ...state.data.location,
            locationsLoading: false,
        },
    },
}));

export const locationsReducer = [load, loadSuccess, loadFailure];
